<template>
    <highcharts class="hc" :ref="refId" :options="options" style="max-height: 500px"></highcharts>
</template>

<script>
    // utils
    import {getKey} from "../../utils/common";
    // constants
    import {chartColors} from "../../constants/chart-constants";
    // external
    import Highcharts from 'highcharts';
    import exportingInit from 'highcharts/modules/exporting';
    import exportingData from "highcharts/modules/export-data";

    // mixins
    import computePlotLinesMixin from "../../mixins/computePlotLinesMixin";
    import ChartZoomControlMixin from "../../mixins/ChartZoomControlMixin";
    import ChartOptionsMixin from "../../mixins/ChartOptionsMixin";

    Highcharts.setOptions({
        colors: chartColors
    });
    exportingInit(Highcharts);
    exportingData(Highcharts);

    /**
     * Wrapper for highcharts component.
     * Has dynamic ref key and zoom reset handler.
     * Initializes localization for the chart and
     * holds the options for SPLINE type charts.
     */

    export default {
        name: "SplineChart",
        mixins: [computePlotLinesMixin, ChartZoomControlMixin, ChartOptionsMixin],
        props: {
            zoomKey: {
                type: Number,
                required: true
            },
            data: {
                type: Object,
                required: true
            },
            metric: {
                type: String
            },
            showPlotLine: {
                type: Boolean
            }
        },
        created() {
            Highcharts.setOptions({
                lang: this.getChartTranslations()
            });
        },
        computed: {
            /**
             * Get a dynamic key for referencing the highcharts object.
             * NOTE: zoom level is controlled viz the zoomKey and this.
             */
            refId() {
                return getKey();
            },
            options() {

                let options = {
                    chart: {
                        zoomType: 'x',
                        type: 'spline',
                        inverted: false
                    },
                    exporting: this.getChartExportingOptions(),
                    title: {
                        text: null
                    },
                    xAxis: {
                        reversed: false,
                        type: 'datetime',
                        title: {
                            text: '',
                            style: {
                                color: "#6299EB"
                            }
                        },
                        startOnTick: true,
                        endOnTick: true,
                        showFirstLabel: true,
                        showLastLabel: true,
                        min: this.data.startDate,
                        max: this.data.endDate
                    },
                    yAxis: {
                        title: {
                            text: this.$i18n.t( this.metric || 'sensors-page.y-label'),
                            style: {
                                color: "#6299EB"
                            }
                        },
                        labels: {
                            x: 0,
                            y: -2
                        }
                    },
                    legend: {
                        enabled: true
                    },
                    credits: {
                        enabled: false
                    }
                };

                // add data
                options.series = this.data.series;
                // add possible plot lines
                if (this.showPlotLine) {
                    options.xAxis.plotLines = this.computePlotLines(this.data.plotLines.xAxis);
                    options.yAxis.plotLines = this.computePlotLines(this.data.plotLines.yAxis);
                }
                return options;
            }
        }
    };
</script>
